import { render, staticRenderFns } from "./OpenSafariDialog.vue?vue&type=template&id=010c0fa0&scoped=true&"
import script from "./OpenSafariDialog.vue?vue&type=script&lang=js&"
export * from "./OpenSafariDialog.vue?vue&type=script&lang=js&"
import style0 from "./OpenSafariDialog.vue?vue&type=style&index=0&id=010c0fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010c0fa0",
  null
  
)

component.options.__file = "OpenSafariDialog.vue"
export default component.exports